const installMediaQueryWatcher = (mediaQuery, changedCallback) => {
  const mq = window.matchMedia(mediaQuery);
  mq.addEventListener("change", (e) => changedCallback(e.matches));
  changedCallback(mq.matches);
};

const deferScriptLoad = (name, src, onload, requestVisualChange = false) => {
  window.Eurus.loadedScript.push(name);

  ((events) => {
    const loadScript = () => {
      events.forEach((type) => window.removeEventListener(type, loadScript));
      clearTimeout(autoloadScript);

      const initScript = () => {
        const script = document.createElement("script");
        script.setAttribute("src", src);
        script.setAttribute("defer", "");
        script.onload = () => {
          document.dispatchEvent(new CustomEvent(name + " loaded"));
          onload();
        };

        document.head.appendChild(script);
      };

      if (requestVisualChange) {
        if (window.requestIdleCallback) {
          requestIdleCallback(initScript);
        } else {
          requestAnimationFrame(initScript);
        }
      } else {
        initScript();
      }
    };

    let autoloadScript;
    if (Shopify.designMode) {
      loadScript();
    } else {
      const wait = window.innerWidth > 767 ? 2000 : 5000;
      events.forEach((type) =>
        window.addEventListener(type, loadScript, { once: true, passive: true })
      );
      autoloadScript = setTimeout(() => {
        loadScript();
      }, wait);
    }
  })(["touchstart", "mouseover", "wheel", "scroll", "keydown"]);
};

const getSectionInnerHTML = (html, selector = ".shopify-section") => {
  return new DOMParser()
    .parseFromString(html, "text/html")
    .querySelector(selector).innerHTML;
};

const xParseJSON = (jsonString) => {
  jsonString = String.raw`${jsonString}`;
  jsonString = jsonString.replaceAll("\\", "\\\\").replaceAll('\\"', '"');

  return JSON.parse(jsonString);
};

window.addEventListener("pageshow", () => {
  document.addEventListener("alpine:init", () => {
    if (Alpine.store("xMiniCart")) {
      if (Alpine.store("xMiniCart").needReload) {
        Alpine.store("xMiniCart").reLoad();
      }
      const isCartPage = document.getElementById("main-cart-items");
      if (isCartPage && Alpine.store("xMiniCart").needReload) {
        location.reload();
      }
      Alpine.store("xMiniCart").needReload = true;
    }
  });
});

requestAnimationFrame(() => {
  document.addEventListener("alpine:init", () => {
    Alpine.store("xDarkMode", {
      toggleThemeMode() {
        if (document.documentElement.classList.contains("dark")) {
          localStorage.eurus_theme = 0;
          document.documentElement.classList.remove("dark");
        } else {
          localStorage.eurus_theme = 1;
          document.documentElement.classList.add("dark");
        }
        Alpine.store("xHeaderMenu").setTopStickyHeader();
      },
    });

    Alpine.store("xHelper", {
      countdown(configs, callback) {
        let endDate = new Date(
          configs.end_year,
          configs.end_month - 1,
          configs.end_day,
          configs.end_hour,
          configs.end_minute
        );
        const endTime =
          endDate.getTime() +
          (-1 * configs.timezone * 60 - endDate.getTimezoneOffset()) *
            60 *
            1000;

        let startTime;
        if (configs.start_year) {
          let startDate = new Date(
            configs.start_year,
            configs.start_month - 1,
            configs.start_day,
            configs.start_hour,
            configs.start_minute
          );
          startTime =
            startDate.getTime() +
            (-1 * configs.timezone * 60 - startDate.getTimezoneOffset()) *
              60 *
              1000;
        } else {
          startTime = new Date().getTime();
        }

        let x = setInterval(function () {
          let now = new Date().getTime();
          let distance = endTime - now;

          if (distance < 0 || startTime > now) {
            callback(false, 0, 0, 0, 0);
            clearInterval(x);
          } else {
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor(
              (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
            );
            var minutes = Math.floor(
              (distance % (1000 * 60 * 60)) / (1000 * 60)
            );
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);
            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;

            callback(true, seconds, minutes, hours, days);
          }
        }, 1000);
      },
      canShow(configs) {
        let endDate = new Date(
          configs.end_year,
          configs.end_month - 1,
          configs.end_day,
          configs.end_hour,
          configs.end_minute
        );
        const endTime =
          endDate.getTime() +
          (-1 * configs.timezone * 60 - endDate.getTimezoneOffset()) *
            60 *
            1000;

        let startTime;
        if (configs.start_year) {
          let startDate = new Date(
            configs.start_year,
            configs.start_month - 1,
            configs.start_day,
            configs.start_hour,
            configs.start_minute
          );
          startTime =
            startDate.getTime() +
            (-1 * configs.timezone * 60 - startDate.getTimezoneOffset()) *
              60 *
              1000;
        } else {
          startTime = new Date().getTime();
        }
        let now = new Date().getTime();
        let distance = endTime - now;
        if (distance < 0 || startTime > now) {
          return false;
        }
        return true;
      },
      handleTime(configs) {
        let endDate = new Date(
          configs.end_year,
          configs.end_month - 1,
          configs.end_day,
          configs.end_hour,
          configs.end_minute
        );
        const endTime =
          endDate.getTime() +
          (-1 * configs.timezone * 60 - endDate.getTimezoneOffset()) *
            60 *
            1000;

        let startTime;
        if (configs.start_year) {
          let startDate = new Date(
            configs.start_year,
            configs.start_month - 1,
            configs.start_day,
            configs.start_hour,
            configs.start_minute
          );
          startTime =
            startDate.getTime() +
            (-1 * configs.timezone * 60 - startDate.getTimezoneOffset()) *
              60 *
              1000;
        } else {
          startTime = new Date().getTime();
        }
        let now = new Date().getTime();
        let distance = endTime - now;
        return {
          startTime: startTime,
          endTime: endTime,
          now: now,
          distance: distance,
        };
      },
    });
  });
});

requestAnimationFrame(() => {
  document.addEventListener("alpine:init", () => {
    Alpine.data("xCart", () => ({
      t: "",
      loading: false,
      updateItemQty(itemId, line) {
        let qty = parseInt(document.getElementById(`cart-qty-${itemId}`).value);
        if (this.validateQty(qty)) {
          this._postUpdateItem(itemId, line, qty);
        }
      },
      minusItemQty(itemId, line) {
        let qty = parseInt(document.getElementById(`cart-qty-${itemId}`).value);
        if (this.validateQty(qty)) {
          if (qty > 0) {
            qty -= 1;
            document.getElementById(`cart-qty-${itemId}`).value = qty;
          }

          this._postUpdateItem(itemId, line, qty);
        }
      },
      plusItemQty(itemId, line) {
        let qty = parseInt(document.getElementById(`cart-qty-${itemId}`).value);
        if (this.validateQty(qty)) {
          if (qty >= 0) {
            qty += 1;
            document.getElementById(`cart-qty-${itemId}`).value = qty;
          }

          this._postUpdateItem(itemId, line, qty);
        }
      },
      removeItem(itemId, line) {
        this._postUpdateItem(itemId, line, 0, 0);
      },
      handleKeydown(evt, el) {
        if (evt.key !== "Enter") return;
        evt.preventDefault();
        el.blur();
        el.focus();
      },
      _postUpdateItem(itemId, line, qty, wait = 500) {
        clearTimeout(this.t);

        const func = () => {
          this.loading = true;
          let removeEl = document.getElementById(`remove-${itemId}`);
          if (removeEl) {
            removeEl.style.display = "none";
          }
          document
            .getElementById(`loading-${itemId}`)
            .classList.remove("hidden");
          const sections = Alpine.store("xCartHelper")
            .getSectionsToRender()
            .map((s) => s.id);
          let updateData = {
            line: `${line}`,
            quantity: `${qty}`,
            sections: sections,
          };

          fetch(`${Shopify.routes.root}cart/change.js`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(updateData),
          })
            .then((response) => response.text())
            .then((state) => {
              const parsedState = JSON.parse(state);

              if (parsedState.status == "422") {
                this._addErrorMessage(itemId, parsedState.message);
                this.updateCart(line);
              } else {
                const items = document.querySelectorAll(".cart-item");
                if (parsedState.errors) {
                  this._addErrorMessage(itemId, parsedState.errors);
                  return;
                }
                Alpine.store("xCartHelper")
                  .getSectionsToRender()
                  .forEach((section) => {
                    const sectionElement = document.querySelector(
                      section.selector
                    );
                    if (sectionElement) {
                      if (parsedState.sections[section.id])
                        sectionElement.innerHTML = getSectionInnerHTML(
                          parsedState.sections[section.id],
                          section.selector
                        );
                    }
                  });

                const currentItemCount =
                  Alpine.store("xCartHelper").currentItemCount;
                Alpine.store("xCartHelper").currentItemCount =
                  parsedState.item_count;
                if (currentItemCount != parsedState.item_count) {
                  document.dispatchEvent(
                    new CustomEvent("eurus:cart:items-changed")
                  );
                }

                const lineItemError = document.getElementById(
                  `LineItemError-${itemId}`
                );
                if (lineItemError) {
                  lineItemError.classList.add("hidden");
                }

                const updatedValue = parsedState.items[line - 1]
                  ? parsedState.items[line - 1].quantity
                  : undefined;

                if (
                  items.length === parsedState.items.length &&
                  updatedValue !== parseInt(qty)
                ) {
                  let message = "";
                  if (typeof updatedValue === "undefined") {
                    message = window.Eurus.cart_error;
                  } else {
                    message = window.Eurus.cart_quantity_error_html.replace(
                      "[quantity]",
                      updatedValue
                    );
                  }
                  this._addErrorMessage(itemId, message);
                }
              }
              let loadingEl = document.getElementById(`loading-${itemId}`);
              let removeEl = document.getElementById(`remove-${itemId}`);
              if (removeEl) {
                removeEl.style.display = "block";
              }
              if (loadingEl) {
                loadingEl.classList.add("hidden");
              }
              this.loading = false;
            });
        };

        this.t = setTimeout(() => {
          func();
        }, wait);
      },
      updateCart(line) {
        fetch(`${window.location.pathname}`)
          .then((reponse) => {
            return reponse.text();
          })
          .then((response) => {
            const parser = new DOMParser();
            const html = parser.parseFromString(response, "text/html");

            const rpCartFooter = html.getElementById("main-cart-footer");
            const cartFooter = document.getElementById("main-cart-footer");
            if (rpCartFooter && cartFooter) {
              cartFooter.innerHTML = rpCartFooter.innerHTML;
            }
            const rpItemInput = html.querySelector(".cart-item-qty-" + line);
            const itemInput = document.querySelector(".cart-item-qty-" + line);
            if (rpItemInput && itemInput) {
              itemInput.value = rpItemInput.value;
            }
            const rpItemTotal = html.querySelector(".cart-item-price-" + line);
            const itemTotal = document.querySelector(
              ".cart-item-price-" + line
            );
            if (itemTotal && rpItemTotal) {
              itemTotal.innerHTML = rpItemTotal.innerHTML;
            }
            const rpPriceTotal = html.querySelector(".cart-drawer-price-total");
            const priceTotal = document.querySelector(
              ".cart-drawer-price-total"
            );
            if (rpPriceTotal && priceTotal) {
              priceTotal.innerHTML = rpPriceTotal.innerHTML;
            }
            const rpCartIcon = html.querySelector("cart-icon-bubble");
            const cartIcon = document.querySelector("cart-icon-bubble");
            if (cartIcon && rpCartIcon) {
              cartIcon.innerHTML = rpCartIcon.innerHTML;
            }
          });
      },
      updateEstimateShipping(el, line, itemId) {
        let qty = parseInt(document.getElementById(`cart-qty-${itemId}`).value);
        let properties = xParseJSON(el.getAttribute("x-data-properties"));
        let updateData = {
          line: `${line}`,
          quantity: `${qty}`,
          properties: properties,
        };
        fetch(`${Shopify.routes.root}cart/change.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updateData),
        }).then((response) => response.text());
      },
      updateDate(date) {
        var formData = {
          attributes: {
            "datetime-updated": `${date}`,
          },
        };
        fetch(Shopify.routes.root + "cart/update", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(formData),
        });
      },
      _addErrorMessage(itemId, message) {
        const lineItemError = document.getElementById(
          `LineItemError-${itemId}`
        );
        if (!lineItemError) return;
        lineItemError.classList.remove("hidden");
        lineItemError.getElementsByClassName(
          "cart-item__error-text"
        )[0].innerHTML = message;
      },
      validateQty: function (number) {
        if (parseFloat(number) != parseInt(number) && isNaN(number)) {
          return false;
        }

        return true;
      },
    }));

    Alpine.store("xCartHelper", {
      currentItemCount: 0,
      validated: true,
      openField: "",
      openDiscountField: "",
      updateCart: function (data, needValidate = false) {
        const formData = JSON.stringify(data);
        fetch(Shopify.routes.root + "cart/update", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: formData,
        }).then(() => {
          if (needValidate) this.validateCart();
        });
      },
      cartValidationRequest() {
        this.validateCart();
        Alpine.store("xMiniCart").openCart();
      },
      validateCart: function () {
        this.validated = true;

        document.dispatchEvent(new CustomEvent("eurus:cart:validate"));
      },
      goToCheckout(e) {
        this.validateCart();

        if (this.validated) {
          let formData = {
            attributes: {
              "collection-pagination": null,
              "blog-pagination": null,
              choose_option_id: null,
              "datetime-updated": null,
            },
          };

          fetch(Shopify.routes.root + "cart/update", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify(formData),
          }).then(() => {
            window.location.href = "/checkout";
          });
        } else {
          e.preventDefault();
        }
      },
      getSectionsToRender() {
        const cartItemEl = document.getElementById("main-cart-items");
        if (cartItemEl) {
          const templateId = cartItemEl
            .closest(".shopify-section")
            .id.replace("cart-items", "")
            .replace("shopify-section-", "");

          return [
            {
              id: templateId + "cart-items",
              selector: "#main-cart-items",
            },
            {
              id: templateId + "cart-footer",
              selector: "#main-cart-footer",
            },
            {
              id: templateId + "cart-upsell",
              selector: "#main-cart-upsell",
            },
            {
              id: "cart-icon-bubble",
              selector: "#cart-icon-bubble",
            },
            {
              id: "mobile-cart-icon-bubble",
              selector: "#mobile-cart-icon-bubble",
            },
          ];
        }

        return [
          {
            id: "cart-icon-bubble",
            selector: "#cart-icon-bubble",
          },
          {
            id: "mobile-cart-icon-bubble",
            selector: "#mobile-cart-icon-bubble",
          },
          {
            id: "cart-drawer",
            selector: "#CartDrawer",
          },
        ];
      },
    });
  });
});

requestAnimationFrame(() => {
  document.addEventListener("alpine:init", () => {
    Alpine.data(
      "xModalSearch",
      (
        type,
        desktopMaximunResults,
        mobileMaximunResults,
        productTypeSelected
      ) => ({
        t: "",
        result: ``,
        query: "",
        cachedResults: [],
        openResults: false,
        productTypeSelected: productTypeSelected,
        showSuggest: false,
        loading: false,
        open() {
          this.$refs.open_search.classList.remove("popup-hidden");
          this.$refs.input_search.focus();
        },
        close() {
          this.$refs.open_search.classList.add("popup-hidden");
        },
        keyUp() {
          this.query = this.$el.value;
          return () => {
            clearTimeout(this.t);
            this.t = setTimeout(() => {
              if (this.query != "") {
                this.showSuggest = false;
                this.getSearchResult(this.query);
              } else {
                this.showSuggest = true;
                this.result = "";
              }
            }, 300);
          };
        },
        getSearchResult(query) {
          this.openResults = true;
          const limit =
            window.innerWidth > 767
              ? desktopMaximunResults
              : mobileMaximunResults;
          let q =
            this.productTypeSelected != productTypeSelected
              ? `${this.productTypeSelected} AND ${query}`
              : query;

          const queryKey = q.replace(" ", "-").toLowerCase() + "_" + limit;

          if (this.cachedResults[queryKey]) {
            this.result = this.cachedResults[queryKey];
            return;
          }

          this.loading = true;

          fetch(
            `${Shopify.routes.root}search/suggest?q=${encodeURIComponent(
              q
            )}&${encodeURIComponent("resources[type]")}=${encodeURIComponent(
              type
            )}&${encodeURIComponent("resources[limit]")}=${encodeURIComponent(
              limit
            )}&section_id=predictive-search`
          )
            .then((response) => {
              return response.text();
            })
            .then((response) => {
              const parser = new DOMParser();
              const text = parser.parseFromString(response, "text/html");
              this.result = text.querySelector(
                "#shopify-section-predictive-search"
              ).innerHTML;
              this.cachedResults[queryKey] = this.result;
            })
            .catch((error) => {
              throw error;
            });
          this.loading = false;
        },
        setProductType(value, input) {
          this.productTypeSelected = value;
          document.getElementById(input).value = value;
          if (this.query != "") {
            this.getSearchResult(this.query);
          }
        },
        focusForm() {
          if (this.$el.value != "") {
            this.showSuggest = false;
          } else {
            this.showSuggest = true;
          }
        },
      })
    );
  });
});

requestAnimationFrame(() => {
  document.addEventListener("alpine:init", () => {
    Alpine.store("xHeaderMenu", {
      isSticky: false,
      stickyCalulating: false,
      isTouch:
        "ontouchstart" in window ||
        (window.DocumentTouch && window.document instanceof DocumentTouch) ||
        window.navigator.maxTouchPoints ||
        window.navigator.msMaxTouchPoints
          ? true
          : false,
      sectionId: "",
      stickyType: "none",
      lastScrollTop: 0,
      themeModeChanged: false,
      showLogoTransparent: true,
      offsetTop: 0,
      clickedHeader: false,
      announcementResizeObserver: null,
      announcementObservedEl: null,
      announcementResizeRaf: null,
      selectItem(el, isSub = false) {
        el.style.setProperty(
          "--header-container-height",
          document.getElementById("x-header-container").offsetHeight + "px"
        );

        if (el.closest(".toggle-menu")) {
          el.style.setProperty(
            "--mega-menu-height",
            el.offsetTop + el.clientHeight + "px"
          );
        }
        this.setAnimationMenu(el, isSub);
        const itemSelector = isSub ? ".toggle-menu-sub" : ".toggle-menu";

        var items = isSub
          ? el.closest(".toggle-menu").querySelectorAll(itemSelector)
          : document.querySelectorAll(itemSelector);

        if (isSub) {
          var subMenuLinks =
            el.parentElement.querySelectorAll(".sub-menu-item");
          for (var i = 0; i < subMenuLinks.length; i++) {
            subMenuLinks[i].classList.remove("is-active");
          }
          el.classList.add("is-active");
        }

        for (var i = 0; i < items.length; i++) {
          if (isSub) {
            items[i].classList.remove("open");
            items[i].classList.add("toggle-menu-sub-hidden");
          } else {
            items[i].classList.add("toggle-menu-hidden");
            items[i]
              .querySelector(".toggle-menu-sub.open")
              ?.classList.add("toggle-menu-sub-hidden");
          }
        }

        let toggleMenu = el.querySelector(itemSelector);

        if (toggleMenu) {
          if (isSub) {
            if (
              el
                .closest(".toggle-menu")
                .classList.contains("mega-menu-vertical")
            ) {
              toggleMenu.classList.add("open");
            }
            toggleMenu.classList.remove("toggle-menu-sub-hidden");
          } else {
            var smNav = toggleMenu.querySelector("[data-simple-menu-balance]");
            if (smNav && smNav.dataset.simpleMenuBalanced !== "true") {
              toggleMenu.classList.remove("toggle-menu-hidden");
              toggleMenu.style.visibility = "hidden";
              toggleMenu.style.position = "absolute";
              requestAnimationFrame(function() {
                balanceSimpleMenu(smNav);
                toggleMenu.style.visibility = "";
                toggleMenu.style.position = "";
                setTimeout(function(){
                            window.dispatchEvent(new Event("resize"));
                },1000)
             
              });
            } else {
              toggleMenu.classList.remove("toggle-menu-hidden");
                setTimeout(function(){
                            window.dispatchEvent(new Event("resize"));
                },1000)
            }
            el.querySelector(".toggle-menu-sub.open")?.classList.remove(
              "toggle-menu-sub-hidden"
            );
          }
        }
      },
      hideMenu(el, isSub = false) {
        var items = isSub
          ? document.querySelectorAll(".toggle-menu-sub")
          : document.querySelectorAll(".toggle-menu");
        if (!isSub) {
          const itemClicked = document.querySelector(".clicked");
          if (itemClicked) {
            itemClicked.classList.remove("clicked");
          }
        } else {
          var subMenuLinks =
            el.parentElement.querySelectorAll(".sub-menu-item");
          for (var i = 0; i < subMenuLinks.length; i++) {
            subMenuLinks[i].classList.remove("is-active");
          }
        }
        for (var i = 0; i < items.length; i++) {
          if (isSub) {
            items[i].classList.add("toggle-menu-sub-hidden");
          } else {
            items[i].classList.add("toggle-menu-hidden");
            items[i]
              .querySelector(".toggle-menu-sub.open")
              ?.classList.add("toggle-menu-sub-hidden");
          }
        }
      },
      hideMenuHorizontal(el) {
        if (!el.querySelector(".toggle-menu-sub")) return;
        if (
          el
            .querySelector(".toggle-menu-sub")
            .classList.contains("toggle-menu-sub-hidden")
        )
          return;
        el.querySelector(".click-sub")?.classList.remove("click-sub");
        this.hideMenu(el, true);
      },
      // start handle touch menu on the ipad
      touchItem(el, isSub = false) {
        const touchClass = isSub ? "touched-sub" : "touched";

        el.addEventListener("touchend", (e) => {
          if (el.classList.contains(touchClass)) {
            window.location.replace(el.getAttribute("href"));
          } else {
            e.preventDefault();
            var dropdown = document.querySelectorAll(`.${touchClass}`);
            for (var i = 0; i < dropdown.length; i++) {
              dropdown[i].classList.remove(touchClass);
            }

            el.classList.add(touchClass);
            this.selectItem(el.closest(".has-dropdown"), isSub);
          }
        });
      },
      clickItem(el, e, isSub = false, isMenu) {
        const clickClass = isSub ? "click-sub" : "clicked";
        if (el.classList.contains(clickClass)) {
          window.location.replace(el.getAttribute("href"));
        } else {
          e.preventDefault();
          var dropdown = document.querySelectorAll(`.${clickClass}`);
          for (var i = 0; i < dropdown.length; i++) {
            dropdown[i].classList.remove(clickClass);
          }
          el.classList.add(clickClass);
          if (!isMenu) {
            this.selectItem(el.closest(".has-dropdown"), isSub);
          }
        }
      },

      // handle sticky header
      initSticky(el, sectionId, stickyType) {
        this.sectionId = sectionId;
        this.stickyType = stickyType;
        this.offsetTop = el.offsetTop;
        this.observeAnnouncementHeight();
        if (this.isSticky) {
          if (
            document
              .querySelector("#sticky-header")
              .classList.contains("on-scroll-up-animation") &&
            document
              .querySelector("#sticky-header")
              .classList.contains("header-up")
          ) {
            Alpine.store("xHeaderMenu").setVariableHeightHeader(false);
          } else {
            Alpine.store("xHeaderMenu").setVariableHeightHeader(true);
          }
        } else {
          this.setVariableHeightHeader(false);
        }
        window.addEventListener("resize", () => {
          this.observeAnnouncementHeight();
          this.reCalculateHeaderHeight();
          if (this.isSticky) {
            if (
              document
                .querySelector("#sticky-header")
                .classList.contains("on-scroll-up-animation") &&
              document
                .querySelector("#sticky-header")
                .classList.contains("header-up")
            ) {
              Alpine.store("xHeaderMenu").setVariableHeightHeader(false);
            } else {
              Alpine.store("xHeaderMenu").setVariableHeightHeader(true);
            }
          } else {
            this.setVariableHeightHeader(false);
          }
          this.setPositionTop();
        });
        this.setPositionTop();
        el.style.height =
          document.getElementById("sticky-header").offsetHeight + "px";
      },
      observeAnnouncementHeight() {
        const announcement = document.querySelector("#x-announcement");
        if (
          this.announcementResizeObserver &&
          this.announcementObservedEl === announcement
        ) {
          return;
        }
        if (this.announcementResizeObserver) {
          this.announcementResizeObserver.disconnect();
          this.announcementResizeObserver = null;
        }
        this.announcementObservedEl = announcement;
        if (!announcement || typeof ResizeObserver !== "function") {
          return;
        }
        this.announcementResizeObserver = new ResizeObserver(() => {
          if (this.announcementResizeRaf) {
            cancelAnimationFrame(this.announcementResizeRaf);
          }
          this.announcementResizeRaf = requestAnimationFrame(() => {
            if (this.isSticky) {
              if (
                document
                  .querySelector("#sticky-header")
                  .classList.contains("on-scroll-up-animation") &&
                document
                  .querySelector("#sticky-header")
                  .classList.contains("header-up")
              ) {
                this.setVariableHeightHeader(false);
              } else {
                this.setVariableHeightHeader(true);
              }
            } else {
              this.setVariableHeightHeader(false);
            }
            this.setPositionTop();
          });
        });
        this.announcementResizeObserver.observe(announcement);
      },
      setPositionTop() {
        let top_height = 0;
        let announcement_height = 0;
        let header_height = 0;
        this.observeAnnouncementHeight();
        const announcement = document.querySelector("#x-announcement");
        const header = document.querySelector("#x-header-container");
        const sectionAnnouncement = document.querySelector(
          ".section-announcement"
        );
        const stickyHeader = document.querySelector("#sticky-header");
        this.setTopStickyHeader();
        if (announcement && announcement.dataset.isSticky == "true") {
          announcement_height = announcement.offsetHeight;
          sectionAnnouncement.style.zIndex = 30;
          sectionAnnouncement.style.top = "0px";
        }
        if (header.dataset.isSticky == "true") {
          header_height = stickyHeader.offsetHeight;
        }
        if (
          document.querySelectorAll(".section-header ~ .section-announcement")
            .length > 0
        ) {
          if (this.isSticky) {
            if (stickyHeader.classList.contains("header-up")) {
              stickyHeader.style.top = "calc(-1 * var(--top-header))";
              sectionAnnouncement.style.top = "0px";
            } else {
              stickyHeader.style.top = "0px";
              sectionAnnouncement.style.top = header_height + "px";
            }
          } else {
            sectionAnnouncement.style.top = "0px";
          }
        } else if (
          document.querySelectorAll(".section-announcement ~ .section-header")
            .length > 0
        ) {
          sectionAnnouncement.style.zIndex = 55;
          if (this.isSticky) {
            if (stickyHeader.classList.contains("header-up")) {
              stickyHeader.style.top = "calc(-1 * var(--top-header))";
            } else {
              stickyHeader.style.top = announcement_height + "px";
            }
          }
        }
      },
      handleAlwaysSticky() {
        const scrollPos =
          window.pageYOffset || document.documentElement.scrollTop;
        const stickyLine = document.getElementById(this.sectionId).offsetTop;

        if (scrollPos > stickyLine) this.addStickyHeader();
      },
      handelOnScrollSticky() {
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;
        if (scrollTop < this.offsetTop) {
          requestAnimationFrame(() => {
            document
              .getElementById("sticky-header")
              .classList.remove("sticky-header");
          });
        }

        if (Math.abs(scrollTop - this.lastScrollTop) > 10) {
          if (scrollTop < this.lastScrollTop) {
            document
              .getElementById("sticky-header")
              .classList.remove("header-up", "opacity-0");
            this.setVariableHeightHeader(true);
          } else if (!this.themeModeChanged) {
            document.getElementById("sticky-header").classList.add("header-up");
            this.setVariableHeightHeader(false);
          }
          this.lastScrollTop = scrollTop;
        }
        this.themeModeChanged = false;
        this.setPositionTop();
      },
      addStickyHeader() {
        let isMiniCartOpen = false;
        if (
          Alpine.store("xMiniCart").open &&
          this.stickyType != "on-scroll-up"
        ) {
          isMiniCartOpen = true;
          requestAnimationFrame(() => {
            Alpine.store("xMiniCart").hideCart();
          });
        }

        requestAnimationFrame(() => {
          let stickyEl = document.getElementById("sticky-header");
          stickyEl.classList.add("sticky-header", "reduce-logo-size");

          this.isSticky = true;
          this.showLogoTransparent = false;
        });

        requestAnimationFrame(() => {
          let stickyEl = document.getElementById("sticky-header");

          if (this.stickyType == "on-scroll-up") {
            setTimeout(() => {
              stickyEl.classList.add("on-scroll-up-animation");
            }, 500);
          }
          if (!Alpine.store("xMiniCart").open || window.innerWidth > 768) {
            if (
              this.stickyType == "always" ||
              this.stickyType == "reduce-logo-size"
            )
              stickyEl.classList.add("always-animation");
          }
        });

        if (isMiniCartOpen) {
          requestAnimationFrame(() => {
            Alpine.store("xMiniCart").openCart();
          });
        }
        requestAnimationFrame(() => {
          this.setPositionTop();
        });
      },
      removeStickyHeader() {
        const scrollPos =
          window.pageYOffset || document.documentElement.scrollTop;
        const stickyLine = document.getElementById(this.sectionId).offsetTop;
        if (scrollPos <= stickyLine) {
          this.isSticky = false;
          this.showLogoTransparent = true;
          requestAnimationFrame(() => {
            document
              .getElementById("sticky-header")
              .classList.remove(
                "sticky-header",
                "reduce-logo-size",
                "always-animation",
                "on-scroll-up-animation"
              );
            this.reCalculateHeaderHeight();
            this.setVariableHeightHeader(false);
            this.setPositionTop();
          });
        }
      },
      handleChangeThemeMode() {
        this.themeModeChanged = true;
        this.reCalculateHeaderHeight();
      },
      reCalculateHeaderHeight() {
        document.getElementById("x-header-container").style.height =
          document.getElementById("sticky-header").offsetHeight + "px";
      },
      addTransparentHover(el) {
        if (this.isTouch && this.clickedHeader) {
          el.classList.add("sticky-header-active");
        } else {
          el.classList.add("sticky-header-active");
        }
      },
      removeTransparentHover(el) {
        if (this.isTouch && this.clickedHeader == false) {
          el.classList.remove("sticky-header-active");
        } else {
          el.classList.remove("sticky-header-active");
        }
      },
      setVariableHeightHeader(sticky) {
        let root = document.documentElement;
        if (sticky) {
          let height_header = document.getElementById("sticky-header")
            ? document.getElementById("sticky-header").offsetHeight
            : 0;
          if (
            document.querySelector("#x-announcement") &&
            document.querySelector("#x-announcement")?.dataset.isSticky ==
              "true"
          ) {
            height_header =
              document.querySelector(".section-announcement").offsetHeight +
              height_header;
          }
          root.style.setProperty("--height-header", height_header + "px");
        } else {
          if (
            document.querySelector("#x-announcement") &&
            document.querySelector("#x-announcement")?.dataset.isSticky ==
              "true"
          ) {
            root.style.setProperty(
              "--height-header",
              document.querySelector(".section-announcement").offsetHeight +
                "px"
            );
          } else {
            root.style.setProperty("--height-header", "0px");
          }
        }
      },
      setTopStickyHeader() {
        let root = document.documentElement;
        let top_height = document.getElementById(
          "sticky-header-content"
        ).offsetHeight;
        root.style.setProperty("--top-header", top_height + "px");
      },
      setHeightScroll(el, index) {
        let toggleMenu = el.querySelector(".toggle-menu-sub");
        if (!el.classList.contains("sub-menu-item")) {
          toggleMenu = el
            .closest(".sub-menu-item")
            .querySelector(".toggle-menu-sub");
        }

        if (toggleMenu) {
          if (index) {
            if (
              index == 1 &&
              el.parentElement.getBoundingClientRect().height <
                toggleMenu.getBoundingClientRect().height
            )
              el.parentElement.style.height =
                toggleMenu.getBoundingClientRect().height.toFixed(2) + "px";
            return;
          }
          el.parentElement.style.height = "auto";
          if (
            el.parentElement.getBoundingClientRect().height <
            toggleMenu.getBoundingClientRect().height
          )
            el.parentElement.style.height =
              toggleMenu.getBoundingClientRect().height.toFixed(2) + "px";
        }
      },
      setAnimationMenu(element, isSub) {
        let el = element;
        if (isSub) {
          el = el.closest(".toggle-menu").closest(".has-dropdown");
        }
        if (el.classList.contains("tabbed-animation-change")) {
          if (isSub == false) {
            if (
              el.querySelector(".toggle-menu") &&
              el.querySelector(".toggle-menu").children[0]
            ) {
              let subMenuHeight = el
                .querySelector(".toggle-menu")
                ?.children[0].querySelector(
                  ".toggle-menu-sub.open"
                )?.clientHeight;
              let initHeight = el.style.getPropertyValue("--init-menu-height");
              if (subMenuHeight > initHeight) {
                el.style.setProperty("--menu-height", subMenuHeight + "px");
              } else {
                el.style.setProperty("--menu-height", initHeight + "px");
              }
            }
          } else {
            let subMenuHeight =
              element.querySelector(".toggle-menu-sub")?.clientHeight;
            let initHeight = el.style.getPropertyValue("--init-menu-height");
            if (subMenuHeight > initHeight) {
              el.style.setProperty("--menu-height", subMenuHeight + "px");
            } else {
              el.style.setProperty("--menu-height", initHeight + "px");
            }
          }
        } else {
          if (isSub == false) {
            let menuHeight = el.style.getPropertyValue("--init-menu-height")
              ? el.style.getPropertyValue("--init-menu-height")
              : el.querySelector(".toggle-menu")?.children[0]?.clientHeight;
            el.style.setProperty("--menu-height", menuHeight + "px");
          }
        }
      },
      initToggleMenuHeight(el) {
        let menuHeight =
          el.querySelector(".toggle-menu")?.children[0]?.clientHeight;
        el.style.setProperty("--init-menu-height", menuHeight);
      },
      tongleHorizontalHeight(el) {
        let height = el.querySelector(".toggle-menu-sub")?.offsetHeight;
        let menuHeight = el.style
          .getPropertyValue("--mega-menu-height")
          .replace("px", "");
        let initHeight = window
          .getComputedStyle(el)
          .getPropertyValue("--init-menu-height");
        if (Number(height) + Number(menuHeight) > Number(initHeight)) {
          el.closest(".toggle-menu").style.setProperty(
            "--menu-height",
            Number(height) + Number(menuHeight) + 10 + "px"
          );
        } else {
          el.closest(".toggle-menu").style.setProperty(
            "--menu-height",
            Number(initHeight) + "px"
          );
        }
      },
    });
  });
});

requestAnimationFrame(() => {
  document.addEventListener("alpine:init", () => {
    Alpine.store("xMobileNav", {
      show: false,
      loading: false,
      currentMenuLinks: [],
      open() {
        this.show = true;
        Alpine.store("xPopup").open = true;
      },
      close() {
        this.show = false;
        Alpine.store("xPopup").close();
      },
      setActiveLink(linkId) {
        this.currentMenuLinks.push(linkId);
      },
      removeActiveLink(linkId) {
        const index = this.currentMenuLinks.indexOf(linkId);
        if (index !== -1) {
          this.currentMenuLinks.splice(index, 1);
        }
      },
      resetMenu() {
        this.currentMenuLinks = [];
      },
      scrollTop(el = null) {
        document.getElementById("menu-navigation").scrollTop = 0;
        if (el) {
          el.closest(".scrollbar-body").scrollTop = 0;
        }
      },
    });

    Alpine.store("xPopup", {
      open: false,
      setWidthScrollbar() {
        // const root = document.documentElement;
        // const clientWidth = root.clientWidth;
        // const width = Math.abs(window.innerWidth - clientWidth);
        // root.style.setProperty('--width-scrollbar', width + "px");
      },
      close() {
        setTimeout(() => {
          this.open = false;
        }, 500);
      },
    });

    Alpine.store("xShowCookieBanner", {
      show: false,
    });

    Alpine.store("xMiniCart", {
      open: false,
      type: "",
      loading: false,
      needReload: false,
      reLoad() {
        this.loading = true;
        const sections = Alpine.store("xCartHelper")
          .getSectionsToRender()
          .map((s) => s.id)
          .join(",");
        fetch(`${window.location.pathname}?sections=${sections}`)
          .then((response) => response.json())
          .then((response) => {
            Alpine.store("xCartHelper")
              .getSectionsToRender()
              .forEach((section) => {
                const sectionElement = document.querySelector(section.selector);
                if (sectionElement && response[section.id]) {
                  sectionElement.innerHTML = getSectionInnerHTML(
                    response[section.id],
                    section.selector
                  );
                }
              });

            this.loading = false;
          });
      },
      openCart() {
        const bcCart = document.getElementById("bc-cart");

        if (bcCart) {
          bcCart.style.overflow = "hidden";
        }

        if (window.location.pathname != "/cart") {
          requestAnimationFrame(() => {
            if (Alpine.store("xQuickView") && Alpine.store("xQuickView").show) {
              Alpine.store("xQuickView").show = false;
            }
          });

          requestAnimationFrame(() => {
            document
              .getElementById("sticky-header")
              .classList.remove("on-scroll-up-animation");

            if (window.innerWidth < 768 || this.type == "drawer") {
              Alpine.store("xPopup").open = true;
            }

            requestAnimationFrame(() => {
              document
                .getElementById("sticky-header")
                .classList.remove("header-up");
              this.open = true;
            });

            if (Alpine.store("xHeaderMenu").stickyType == "on-scroll-up") {
              setTimeout(() => {
                requestAnimationFrame(() => {
                  document
                    .getElementById("sticky-header")
                    .classList.add("on-scroll-up-animation");
                });
              }, 200);
            }
          });

          setTimeout(() => {
            if (!window.Rebuy) return;

            window.Rebuy.init();
          }, 1000);
        }
      },
      hideCart() {
        const bcCart = document.getElementById("bc-cart");

        if (bcCart) {
          bcCart.style.overflow = "auto";
        }

        requestAnimationFrame(() => {
          this.open = false;
          Alpine.store("xPopup").close();
        });
      },
    });

    Alpine.store("xModal", {
      activeElement: "",
      setActiveElement(element) {
        this.activeElement = element;
      },
      focus(container, elementFocus) {
        Alpine.store("xFocusElement").trapFocus(container, elementFocus);
      },
      removeFocus() {
        const openedBy = document.getElementById(this.activeElement);
        Alpine.store("xFocusElement").removeTrapFocus(openedBy);
      },
    });

    Alpine.store("xFocusElement", {
      focusableElements: [
        'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])',
      ],
      listeners: {},
      trapFocus(container, elementFocus) {
        if (window.innerWidth < 1025) return;

        let c = document.getElementById(container);
        let e = document.getElementById(elementFocus);
        this.listeners = this.listeners || {};
        const elements = Array.from(c.querySelectorAll(this.focusableElements));
        var first = elements[0];
        var last = elements[elements.length - 1];

        this.removeTrapFocus();

        this.listeners.focusin = (event) => {
          if (
            event.target !== c &&
            event.target !== last &&
            event.target !== first
          ) {
            return;
          }
          document.addEventListener("keydown", this.listeners.keydown);
        };

        this.listeners.focusout = () => {
          document.removeEventListener("keydown", this.listeners.keydown);
        };

        this.listeners.keydown = (e) => {
          if (e.code.toUpperCase() !== "TAB") return;

          if (e.target === last && !e.shiftKey) {
            e.preventDefault();
            first.focus();
          }

          if ((e.target === first || e.target == c) && e.shiftKey) {
            e.preventDefault();
            last.focus();
          }
        };
        document.addEventListener("focusout", this.listeners.focusout);
        document.addEventListener("focusin", this.listeners.focusin);
        e.focus();
      },
      removeTrapFocus(elementToFocus = null) {
        if (window.innerWidth < 1025) return;

        document.removeEventListener("focusin", () => {
          document.addEventListener("keydown", this.listeners.focusin);
        });
        document.removeEventListener("focusout", () => {
          document.removeEventListener("keydown", this.listeners.focusout);
        });
        document.removeEventListener("keydown", this.listeners.keydown);
        if (elementToFocus) elementToFocus.focus();
      },
    });

    Alpine.data("xTruncateText", () => ({
      truncateEl: "",
      truncateInnerEl: "",
      truncated: false,
      truncatable: false,
      expanded: false,
      load(truncateEl) {
        const truncateRect = truncateEl.getBoundingClientRect();
        truncateEl.style.setProperty(
          "--truncate-height",
          `${truncateRect.height}px`
        );
      },
      setTruncate(element) {
        if (
          element.offsetHeight < element.scrollHeight ||
          element.offsetWidth < element.scrollWidth
        ) {
          this.truncated = true;
          this.truncatable = true;
          this.expanded = false;
        } else {
          this.truncated = false;
          this.truncatable = false;
          this.expanded = true;
        }
      },
      open(el) {
        const truncateEl = el
          .closest(".truncate-container")
          .querySelector(".truncate-text");
        if (truncateEl.classList.contains("truncate-expanded")) {
          truncateEl.classList.remove("truncate-expanded");
          this.expanded = false;
          this.truncated = true;
          return;
        }

        this.expanded = true;
        const truncateInnerEl = truncateEl.querySelector(".truncate-inner");
        window.requestAnimationFrame(() => {
          const truncateInnerRect = truncateInnerEl.getBoundingClientRect();
          truncateEl.style.setProperty(
            "--truncate-height-expanded",
            `${truncateInnerRect.height}px`
          );
          truncateEl.classList.add("truncate-expanded");
        });
        this.truncated = false;
      },
    }));
  });
});

requestAnimationFrame(() => {
  document.addEventListener("alpine:init", () => {
    Alpine.store("xCartAnalytics", {
      viewCart() {
        fetch("/cart.js")
          .then((response) => {
            return response.text();
          })
          .then((cart) => {
            cart = JSON.parse(cart);
            if (cart.items.length > 0) {
              Shopify.analytics.publish("view_cart", { cart: cart });
            }
          });
      },
    });
  });
});

requestAnimationFrame(() => {
  document.addEventListener("alpine:init", () => {
    Alpine.store("xCustomerEvent", {
      fire(eventName, el, data) {
        if (Shopify.designMode) return;

        const formatedData = data
          ? data
          : xParseJSON(el.getAttribute("x-customer-event-data"));
        Shopify.analytics.publish(eventName, formatedData);
      },
    });
  });
});

requestAnimationFrame(() => {
  document.addEventListener("alpine:init", () => {
    Alpine.store("xSplide", {
      load(el, configs) {
        const initSlider = () => {
          const id = el.getAttribute("id");
          if (configs.classes != undefined) {
            if (!configs.classes.arrow)
              configs.classes.arrow =
                "arrow w-8 h-8 p-2 absolute z-10 top-1/2 -translate-y-1/2 hidden md:flex items-center justify-center";
            if (!configs.classes.next) configs.classes.next = "right-0";
            if (!configs.classes.prev) configs.classes.prev = "-rotate-180";
          }
          let splide = new Splide("#" + id, configs);
          if (configs.thumbs) {
            let thumbsRoot = document.getElementById(configs.thumbs);
            let thumbs = thumbsRoot.getElementsByClassName("x-thumbnail");
            let current;
            let _this = this;

            for (let i = 0; i < thumbs.length; i++) {
              if (thumbs[i] == current) {
                thumbs[i].classList.remove("opacity-30");
              } else {
                thumbs[i].classList.add("opacity-30");
              }
              thumbs[i].addEventListener("click", function () {
                _this.moveThumbnail(
                  i,
                  thumbs[i],
                  thumbsRoot,
                  configs.thumbs_direction,
                  configs.direction
                );
                splide.go(i);
              });
            }

            splide.on("refresh", function () {
              for (let i = 0; i < thumbs.length; i++) {
                thumbs[i].removeEventListener("click", function () {
                  _this.moveThumbnail(
                    i,
                    thumbs[i],
                    thumbsRoot,
                    configs.thumbs_direction,
                    configs.direction
                  );
                  splide.go(i);
                });
              }

              let thumbsRoot = document.getElementById(configs.thumbs);
              let thumbsNew = thumbsRoot.getElementsByClassName("x-thumbnail");

              for (let i = 0; i < thumbsNew.length; i++) {
                if (i == 0) {
                  thumbsNew[i].classList.remove("opacity-30");
                } else {
                  thumbsNew[i].classList.add("opacity-30");
                }

                thumbsNew[i].addEventListener("click", function () {
                  _this.moveThumbnail(
                    i,
                    thumbsNew[i],
                    thumbsRoot,
                    configs.thumbs_direction,
                    configs.direction
                  );
                  splide.go(i);
                });
              }
            });
            splide.on("mounted move", function () {
              let thumbnail = thumbs[splide.index];
              if (thumbnail) {
                if (current) {
                  current.classList.add("opacity-30");
                }
                thumbnail.classList.remove("opacity-30");
                current = thumbnail;
                _this.moveThumbnail(
                  splide.index,
                  thumbnail,
                  thumbsRoot,
                  configs.thumbs_direction,
                  configs.direction
                );
              }
            });
          }

          if (configs.hotspot) {
            let hotspotRoot = document.getElementById(configs.hotspot);
            let hotspots = hotspotRoot.getElementsByClassName("x-hotspot");
            let current;

            if (
              configs.disableHoverOnTouch &&
              ("ontouchstart" in window ||
                (window.DocumentTouch &&
                  window.document instanceof DocumentTouch) ||
                window.navigator.maxTouchPoints ||
                window.navigator.msMaxTouchPoints)
            ) {
              for (let i = 0; i < hotspots.length; i++) {
                hotspots[i].addEventListener("click", function () {
                  splide.go(i);
                });
              }
            } else {
              for (let i = 0; i < hotspots.length; i++) {
                hotspots[i].addEventListener("mouseover", function () {
                  splide.go(i);
                });
                hotspots[i].addEventListener("focus", function () {
                  splide.go(i);
                });
              }
            }
            splide.on("mounted move", function () {
              let hotspot = hotspots[splide.index];

              if (hotspot) {
                if (current) {
                  current.classList.remove("active-hotspot");
                }
                hotspot.classList.add("active-hotspot");
                current = hotspot;
              }
            });
          }
          if (configs.cardHover) {
            let cardImage = document.getElementById(configs.cardHover);
            if (window.innerWidth > 1024) {
              cardImage.addEventListener("mousemove", function (e) {
                let left = e.offsetX;
                let width = cardImage.getBoundingClientRect().width;
                let spacing = left / width;
                let index = Math.floor(spacing * configs.maxSlide);
                splide.go(index);
              });
              cardImage.addEventListener("mouseleave", function (e) {
                splide.go(0);
              });
            }
          }
          if (configs.progressBar) {
            var bar = splide.root.querySelector(".splide-progress-bar");
            splide.on("mounted move", function () {
              var end = configs.progressBar;
              if (configs.progressBarHeader) {
                end = splide.Components.Slides.getLength();
              }
              var rate = 100 * (splide.index / end);
              if (bar) {
                var rateBar = rate + Number(bar.style.width.replace("%", ""));
                var maxRate = 100 - Number(bar.style.width.replace("%", ""));
                if (rateBar > 100) {
                  rate = maxRate;
                }
                if (document.querySelector("body").classList.contains("rtl")) {
                  bar.style.marginRight = rate + "%";
                } else {
                  bar.style.marginLeft = rate + "%";
                }
              }
            });
          }
          if (el.classList.contains("card-product-img")) {
            splide.on("resized", function () {
              var height =
                splide.root.querySelector(".splide__track").offsetHeight;
              splide.Components.Slides.get().forEach((item) => {
                item.slide.style.height = height + "px";
              });
            });
          }

          if (configs.events) {
            configs.events.forEach((e) => {
              splide.on(e.event, e.callback);
            });
          }

          el.splide = splide;
          splide.mount();

          if (configs.playOnHover) {
            splide.Components.Autoplay.pause();
            el.onmouseover = function () {
              splide.Components.Autoplay.play();
            };
            el.onmouseout = function () {
              splide.Components.Autoplay.pause();
            };
          }
        };

        if (!window.Eurus.loadedScript.includes("slider")) {
          deferScriptLoad(
            "slider",
            window.Eurus.sliderScript,
            initSlider,
            true
          );
        } else if (window.Splide) {
          initSlider();
        } else {
          document.addEventListener("slider loaded", () => {
            initSlider();
          });
        }
      },
      moveThumbnail(index, thumbnail, thumbsRoot, direction) {
        if (!thumbnail || !thumbsRoot) return;

        const scroller =
          thumbsRoot.querySelector("[data-pdp-thumbnail-scroll]") || thumbsRoot;

        setTimeout(() => {
          if (direction === "vertical") {
            const scrollerRect = scroller.getBoundingClientRect();
            const thumbRect = thumbnail.getBoundingClientRect();
            const delta =
              thumbRect.top +
              thumbRect.height / 2 -
              (scrollerRect.top + scrollerRect.height / 2);

            scroller.scrollTop = Math.max(
              0,
              Math.min(
                scroller.scrollTop + delta,
                scroller.scrollHeight - scroller.clientHeight
              )
            );
          } else {
            const scrollerRect = scroller.getBoundingClientRect();
            const thumbRect = thumbnail.getBoundingClientRect();
            const delta =
              thumbRect.left +
              thumbRect.width / 2 -
              (scrollerRect.left + scrollerRect.width / 2);

            scroller.scrollLeft = Math.max(
              0,
              Math.min(
                scroller.scrollLeft + delta,
                scroller.scrollWidth - scroller.clientWidth
              )
            );
          }
        }, 50);
      },
    });
  });
});

requestAnimationFrame(() => {
  document.addEventListener("alpine:init", () => {
    Alpine.data("xParallax", () => ({
      debounce(func, wait) {
        var timeout;
        return function () {
          var context = this,
            args = arguments;
          var later = function () {
            timeout = null;
            func.apply(context, args);
          };
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
        };
      },
      load(disable) {
        if (disable) return;

        if (
          "IntersectionObserver" in window &&
          "IntersectionObserverEntry" in window
        ) {
          const observerOptions = {
            root: null,
            rootMargin: "0px 0px",
            threshold: 0,
          };

          var observer = new IntersectionObserver(
            handleIntersect,
            observerOptions
          );
          var el;
          function handleIntersect(entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                el = entry.target;
                window.addEventListener("scroll", parallax, {
                  passive: true,
                  capture: false,
                });
              } else {
                window.removeEventListener("scroll", parallax, {
                  passive: true,
                  capture: false,
                });
              }
            });
          }

          observer.observe(this.$el);

          var parallax = this.debounce(function () {
            var rect = el.getBoundingClientRect();
            var speed =
              (window.innerHeight / el.parentElement.offsetHeight) * 20;
            var shiftDistance = (rect.top - window.innerHeight) / speed;
            var maxShiftDistance = el.parentElement.offsetHeight / 11;

            if (
              shiftDistance < -maxShiftDistance ||
              shiftDistance > maxShiftDistance
            ) {
              shiftDistance = -maxShiftDistance;
            }

            el.style.transform = "translate3d(0, " + shiftDistance + "px, 0)";
          }, 10);
        }
      },
    }));
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var giftCheckbox = document.getElementById("gift-checkbox");
  var giftMessageBox = document.getElementById("gift-message-box");
  const giftMessage = document.getElementById("gift-message");
  const giftMessageWarning = document.getElementById("gift-message__warning");

  if (giftCheckbox && giftMessageBox) {
    giftCheckbox.addEventListener("change", function () {
      if (this.checked) {
        giftMessageBox.style.display = "flex";
      } else {
        giftMessageBox.style.display = "none";
      }
    });
  }

  if (giftMessage && giftMessageWarning) {
    giftMessage.addEventListener("input", function (e) {
      if (e.target.value.length >= 250) {
        giftMessageWarning.style.display = "block";
      } else {
        giftMessageWarning.style.display = "none";
      }
    });
  }
});

const SIMPLE_MENU_BALANCE_BREAKPOINT = 768;
const SIMPLE_MENU_SECTION_GAP = 24;
const SIMPLE_MENU_MIN_CONTINUATION_ITEMS = 3;

function applySimpleMenuShopAllStyles(nav) {
  if (!nav) return;

  var raw = nav.dataset.simpleMenuHighlight || "";
  var highlightTexts = raw
    .split(",")
    .map(function(s) { return s.trim().toLowerCase(); })
    .filter(Boolean);

  if (!highlightTexts.length) return;

  nav.querySelectorAll("a").forEach(function(link) {
    var text = link.textContent.trim().toLowerCase();
    if (highlightTexts.includes(text)) {
      link.classList.add("simple-menu-shop-all-link");
    }
  });
}

function restoreSimpleMenuBalance(nav) {
  if (!nav || !nav.dataset.simpleMenuOriginalHtml) return;
  if (nav.dataset.simpleMenuBalanced === "true") {
    nav.innerHTML = nav.dataset.simpleMenuOriginalHtml;
    nav.classList.remove("simple-menu-balanced-mode");
    nav.style.removeProperty("--simple-menu-columns");
    nav.dataset.simpleMenuBalanced = "false";
  }
  applySimpleMenuShopAllStyles(nav);
}

function getSimpleMenuColumnCount(nav) {
  const sourceCount = parseInt(nav.dataset.simpleMenuColumnCount || "0", 10);
  const hasImage = nav.dataset.simpleMenuHasImage === "true";
  let columnCount = sourceCount > 0 ? sourceCount : nav.children.length;

  if (hasImage && columnCount > 4) columnCount = 4;
  if (!hasImage && columnCount > 5) columnCount = 5;

  return Math.max(columnCount, 1);
}

function measureSimpleMenuSections(nav) {
  const sections = [];
  const items = Array.from(nav.children).filter((child) => child.tagName === "LI");

  items.forEach((item) => {
    const heading = item.querySelector(":scope > .nav-link-outer");
    const list = item.querySelector(":scope > ul");
    const links = list
      ? Array.from(list.children).map((linkItem) => ({
          html: linkItem.outerHTML,
          height: linkItem.offsetHeight,
        }))
      : [];

    sections.push({
      headingHTML: heading ? heading.outerHTML : "",
      headingHeight: heading ? heading.offsetHeight : 0,
      links,
    });
  });

  return sections;
}

function balanceSimpleMenu(nav) {
  if (!nav || !nav.hasAttribute("data-simple-menu-balance")) return;

  if (!nav.dataset.simpleMenuOriginalHtml) {
    nav.dataset.simpleMenuOriginalHtml = nav.innerHTML;
    nav.dataset.simpleMenuBalanced = "false";
  }

 if (nav.dataset.simpleMenuBalanced === "true" && nav.dataset.simpleMenuLastWidth === String(window.innerWidth)) {
    return;
  }

  if (nav.dataset.simpleMenuBalanced === "true") {
    nav.innerHTML = nav.dataset.simpleMenuOriginalHtml;
    nav.classList.remove("simple-menu-balanced-mode");
    nav.style.removeProperty("--simple-menu-columns");
    nav.dataset.simpleMenuBalanced = "false";
  }

if (window.innerWidth < SIMPLE_MENU_BALANCE_BREAKPOINT) {
    applySimpleMenuShopAllStyles(nav);
    return;
  }

  const maxItems = parseInt(nav.dataset.simpleMenuMaxItems || "13", 10);
  const sections = measureSimpleMenuSections(nav);
  const splitCandidates = sections.filter((section) => section.links.length > maxItems);

  if (!splitCandidates.length) {
    applySimpleMenuShopAllStyles(nav);
    nav.dataset.simpleMenuBalanced = "true";
    nav.dataset.simpleMenuLastWidth = String(window.innerWidth);
    return;
  }

  const columnCount = getSimpleMenuColumnCount(nav);
  const columnMaxHeight = Math.max(
    ...splitCandidates.map((section) => {
      const visibleLinks = section.links.slice(0, maxItems);
      return (
        section.headingHeight +
        visibleLinks.reduce((height, link) => height + link.height, 0)
      );
    })
  );

  const columns = Array.from({ length: columnCount }, () => []);
  let currentColumn = 0;
  let currentHeight = 0;

  const moveToNextColumn = () => {
    if (currentColumn < columns.length - 1) {
      currentColumn += 1;
      currentHeight = 0;
      return true;
    }
    return false;
  };

  sections.forEach((section) => {
    let remainingLinks = section.links.slice();
    let renderHeading = true;

    while (remainingLinks.length) {
      const headingHeight = renderHeading ? section.headingHeight : 0;
      const firstLinkHeight = remainingLinks[0] ? remainingLinks[0].height : 0;
      const availableHeight = columnMaxHeight - currentHeight;

      if (
        currentHeight > 0 &&
        headingHeight + firstLinkHeight > availableHeight &&
        moveToNextColumn()
      ) {
        continue;
      }

      let segmentHeight = headingHeight;
      const segmentLinks = [];
      const maxAvailableHeight = columnMaxHeight - currentHeight;

      for (const link of remainingLinks) {
        if (
          segmentLinks.length > 0 &&
          segmentHeight + link.height > maxAvailableHeight
        ) {
          break;
        }

        segmentLinks.push(link);
        segmentHeight += link.height;
      }

      if (!segmentLinks.length && remainingLinks.length) {
        segmentLinks.push(remainingLinks[0]);
        segmentHeight = headingHeight + remainingLinks[0].height;
      }

      let continuationCount = remainingLinks.length - segmentLinks.length;
      while (
        continuationCount > 0 &&
        continuationCount < SIMPLE_MENU_MIN_CONTINUATION_ITEMS &&
        segmentLinks.length > SIMPLE_MENU_MIN_CONTINUATION_ITEMS
      ) {
        const movedLink = segmentLinks.pop();
        segmentHeight -= movedLink.height;
        continuationCount += 1;
      }

      const sectionMarkup = {
        headingHTML: renderHeading ? section.headingHTML : "",
        linksHTML: segmentLinks.map((link) => link.html),
      };

      const lastSection = columns[currentColumn][columns[currentColumn].length - 1];
      if (!sectionMarkup.headingHTML && lastSection) {
        lastSection.linksHTML.push(...sectionMarkup.linksHTML);
      } else {
        columns[currentColumn].push(sectionMarkup);
      }

      remainingLinks = remainingLinks.slice(segmentLinks.length);
      currentHeight += segmentHeight + SIMPLE_MENU_SECTION_GAP;
      renderHeading = false;

      if (remainingLinks.length) moveToNextColumn();
    }
  });

  nav.classList.add("simple-menu-balanced-mode");
  nav.style.setProperty("--simple-menu-columns", String(columnCount));
  nav.innerHTML = columns
    .map((column) => {
      const sectionsMarkup = column
        .map(
          (section) => `
            <div class="simple-menu-balanced-section">
              ${section.headingHTML}
              <ul class="list-unstyled" role="list">
                ${section.linksHTML.join("")}
              </ul>
            </div>
          `
        )
        .join("");

      return `<li class="simple-menu-balanced-column">${sectionsMarkup}</li>`;
    })
    .join("");
 nav.dataset.simpleMenuBalanced = "true";
  nav.dataset.simpleMenuLastWidth = String(window.innerWidth);
  applySimpleMenuShopAllStyles(nav);
}

function scheduleSimpleMenuBalance(toggleMenu) {
  return;
}

const sizeGuide = document.querySelectorAll(".size-guide");
const sizeOverlay = document.querySelector(".size-overlay");
const closeButton = document.querySelector(".size-close");
const guideContainer = document.querySelector(".guide-container");
const productInfo = document.querySelector(".product-info");
const sizeOverlayOriginalParent = sizeOverlay?.parentNode ?? null;
const sizeOverlayOriginalNextSibling = sizeOverlay?.nextSibling ?? null;

function restoreSizeOverlayPosition() {
  if (!sizeOverlay || !sizeOverlayOriginalParent) return;

  if (sizeOverlayOriginalNextSibling) {
    sizeOverlayOriginalParent.insertBefore(
      sizeOverlay,
      sizeOverlayOriginalNextSibling
    );
  } else {
    sizeOverlayOriginalParent.appendChild(sizeOverlay);
  }
}

// Function to open the modal
function openModal() {
  if (!sizeOverlay) return;

  document.body.appendChild(sizeOverlay);
  sizeOverlay.classList.add("is-active");
  document.body.classList.add("modal-open"); // Prevent background scrolling
  productInfo?.classList.remove("sticky");
}

// Function to close the modal
function closeModal() {
  if (!sizeOverlay) return;

  sizeOverlay.classList.remove("is-active");
  document.body.classList.remove("modal-open"); // Restore background scrolling
  restoreSizeOverlayPosition();
  productInfo?.classList.add("sticky");
}

// Event listener for opening the modal
if (sizeGuide) {
  sizeGuide.forEach((guide) => {
    guide.addEventListener("click", openModal);
  });
}

// Event listener for closing the modal with the close button
if (closeButton) {
  closeButton.addEventListener("click", closeModal);
}

// Event listener for closing the modal when clicking outside the guide container
if (sizeOverlay) {
  sizeOverlay.addEventListener("click", (event) => {
    if (event.target === sizeOverlay) {
      closeModal();
    }
  });
}

// Prevent clicks inside the guide container from closing the modal
if (guideContainer) {
  guideContainer.addEventListener("click", (event) => {
    event.stopPropagation();
  });
}

window.addEventListener("DOMContentLoaded", () => {
  const _el = {
    button: document.querySelector(".buy-button-container"),
    label: document.querySelector(".pre-order-label"),
  };

  const _fn = {
    _hideInventoryStatus() {
      document.querySelectorAll('[id^="block-inventory-"]').forEach((inventory) => {
        inventory.classList.add('hidden');
      });
    },
    _init: () => {
      console.log("ELEMENTS:", _el);

      // Check if the button element exists before trying to observe it
      if (!_el.button) {
        console.log("Buy button container not found, skipping mutation observer setup");
        return;
      }

      // _el.button.addEventListener("DOMSubtreeModified", (e) => _fn._handleChange(e));

      const observador = new MutationObserver((mutaciones) => {
        mutaciones.forEach((mutacion) => {
          if (mutacion.type === "childList") {
            _fn._handleChange(mutacion);
          }
        });
      });

      observador.observe(_el.button, { childList: true, subtree: true });
    },
    _handleChange: (e) => {
      if (!e.target || !e.target.classList || !_el.label) {
        return;
      }
      
      if (e.target.classList.contains("x-atc-text")) {
        console.log(
          "El contenido del elemento ha cambiado.",
          e.target.textContent.toLowerCase()
        );

        _el.label.textContent = e.target.textContent;
        _el.label.classList.add("flex");
        _el.label.classList.remove("hidden");
        _fn._hideInventoryStatus();
      }
    },
  };

  _fn._init();

  if (
    _el.label &&
    !_el.label.classList.contains("hidden") &&
    _el.label.textContent.trim() !== ""
  ) {
    _fn._hideInventoryStatus();
  }
});

document.querySelectorAll("input[name='select-date']").forEach((input) => {
  const storePickupAppWrapper = document.getElementById(
    "storePickupAppWrapper"
  );

  console.log("🚀 ~ storePickupAppWrapper:", storePickupAppWrapper);

  input.addEventListener("change", (e) => {
    console.log("Change", e.target.value);
    if (e.target.value == 0) {
      storePickupAppWrapper.classList.add("active");
    } else if (e.target.value == 1) {
      storePickupAppWrapper.classList.remove("active");
    }
  });
});

const prLoadFloatingElements = () => {
  const elements = [
    "ProductFilter",
    "xMobileNav",
    "CartDrawer",
    "QuickView",
    "QuickViewMobile",
  ];

  elements.forEach((element) => {
    const el = document.getElementById(element);
    if (el) {
      el.classList.remove("opacity-0");
    }
  });
};

const getHeaderScrollOffset = (extraOffset = 64) => {
  const stickyHeader = document.getElementById("sticky-header");
  const announcement = document.querySelector("#x-announcement");
  const announcementBar = document.querySelector(".section-announcement");
  let height = 0;

  if (stickyHeader) {
    height += stickyHeader.offsetHeight;
  }

  if (announcement?.dataset.isSticky === "true" && announcementBar) {
    height += announcementBar.offsetHeight;
  }

  if (!height) {
    const headerHeight = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue("--height-header"),
      10
    );
    height = Number.isFinite(headerHeight) ? headerHeight : 80;
  }

  return height + extraOffset;
};

const scrollToReviewsWidget = (extraOffset = 64) => {
  const widget = document.querySelector("reviewsio-product-reviews-widget");
  if (!widget) return false;

  const top =
    widget.getBoundingClientRect().top +
    window.scrollY -
    getHeaderScrollOffset(extraOffset);

  window.scrollTo({ top, behavior: "smooth" });
  return true;
};

const initProductReviewsScroll = () => {
  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-scroll-to-reviews]");
    if (!trigger) return;

    event.preventDefault();

    if (scrollToReviewsWidget()) return;

    let attempts = 0;
    const retry = window.setInterval(() => {
      attempts += 1;
      if (scrollToReviewsWidget() || attempts >= 20) {
        window.clearInterval(retry);
      }
    }, 250);
  });
};

const reviewsIoOnload = () => {
  const reviewsIonBanner = document.querySelector("reviewsio-rating-bar");
  // console.log("🚀 ~ reviewsIoOnload ~ reviewsIonBanner:", reviewsIonBanner)

  if (reviewsIonBanner) {
    reviewsIonBanner.addEventListener("click", () => {
      setTimeout(() => {
        window.location.href = 'https://www.reviews.co.uk/company-reviews/store/carbethplants.co.uk';
      }, 300);
    })
  }
}

window.addEventListener("DOMContentLoaded", () => {
  initProductReviewsScroll();

  setTimeout(() => {
    const preOrderProducts = document.querySelectorAll(
      ".card-product picture.gPreorderImageWrapper"
    );

    prLoadFloatingElements();
    reviewsIoOnload();

    if (preOrderProducts) {
      preOrderProducts.forEach((product) => {
        product.querySelector(".pre-order_label").classList.add("active");
      });
    }


  }, 1500);
});

window.addEventListener("resize", () => {
  document.querySelectorAll("[data-simple-menu-balance]").forEach((nav) => {
    const toggleMenu = nav.closest(".toggle-menu");

    if (toggleMenu && !toggleMenu.classList.contains("toggle-menu-hidden")) {
      balanceSimpleMenu(nav);
    } else {
      restoreSimpleMenuBalance(nav);
    }
  });
});
